import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.PROCESSO.SET_FILTRO_PROCESSOS_LISTAGEM](state, filtro) {
		FiltroUtils.setarFiltro(state.filtro, filtro)
	},

	[mutationTypes.PROCESSO.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},
}
